import React, { useState, useEffect } from 'react';
import {
  Container,
  Box,
  Typography,
  Paper,
  CircularProgress,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
} from '@mui/material';
import { Description as DescriptionIcon } from '@mui/icons-material';
import * as XLSX from 'xlsx';

const BlueprintPage = () => {
  const [data, setData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchExcel = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // 从后端获取Excel文件
        const response = await fetch('http://139.224.28.156:5000/files/endfiled_blueprint.xlsx');
        
        if (!response.ok) {
          throw new Error(`无法加载文件: ${response.status} ${response.statusText}`);
        }
        
        // 获取二进制数据
        const arrayBuffer = await response.arrayBuffer();
        
        // 使用xlsx库解析
        const workbook = XLSX.read(arrayBuffer, { type: 'array' });
        
        // 获取第一个工作表
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        
        // 转换为JSON格式
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        
        if (jsonData.length > 0) {
          // 第一行作为表头
          setHeaders(jsonData[0]);
          // 其余行作为数据
          setData(jsonData.slice(1));
        }
      } catch (err) {
        console.error('读取Excel文件失败:', err);
        setError(err.message || '加载数据失败');
      } finally {
        setLoading(false);
      }
    };

    fetchExcel();
  }, []);

  if (loading) {
    return (
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
          <CircularProgress size={60} />
        </Box>
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
        <Typography variant="body2" color="text.secondary">
          请确保文件路径正确: http://139.224.28.156:5000/files/endfiled_blueprint.xlsx
        </Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      {/* 页面标题 */}
      <Box sx={{ mb: 4 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <DescriptionIcon sx={{ fontSize: 40, mr: 2, color: 'primary.main' }} />
          <Typography variant="h3" fontWeight="bold">
            基建蓝图库
          </Typography>
        </Box>
        <Typography variant="body1" color="text.secondary">
          基建蓝图数据一览
        </Typography>
        {data.length > 0 && (
          <Chip 
            label={`共 ${data.length} 条数据`} 
            color="primary" 
            variant="outlined"
            sx={{ mt: 2 }}
          />
        )}
      </Box>

      {/* 数据表格 */}
      {data.length > 0 ? (
        <TableContainer 
          component={Paper} 
          sx={{ 
            boxShadow: 3,
            maxHeight: '70vh',
            '& .MuiTableCell-head': {
              bgcolor: 'primary.main',
              color: 'white',
              fontWeight: 'bold',
              fontSize: '1rem',
              position: 'sticky',
              top: 0,
              zIndex: 10,
            },
            '& .MuiTableRow-root:hover': {
              bgcolor: 'action.hover',
            }
          }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {headers.map((header, index) => (
                  <TableCell key={index} align="center">
                    {header || `列${index + 1}`}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  {row.map((cell, cellIndex) => (
                    <TableCell 
                      key={cellIndex} 
                      align="center"
                      sx={{
                        borderRight: cellIndex < row.length - 1 ? '1px solid rgba(224, 224, 224, 1)' : 'none'
                      }}
                    >
                      {cell !== null && cell !== undefined ? String(cell) : '-'}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Alert severity="info">
          暂无数据
        </Alert>
      )}
    </Container>
  );
};

export default BlueprintPage;
